const applyRouter = {
    path: '/apply',
    name: 'Apply',
    meta: {
      title: '报考'
    },
  component: () => import('@/views/applyTest/index.vue'),
  redirect: '/test',

  children: [
      {
        path: '/test',
        name: 'Test',

        component: () => import('@/views/applyTest/test.vue'),
        meta: {
          hideHead: true,
          hideFoot: true
        }
      },
      {
        path: '/score',
        name: 'Score',

        component: () => import('@/views/applyTest/score.vue'),
        meta: {
          hideHead: true,
          hideFoot: true
        }
      },
      {
        path: '/applyinfo',
        name: 'ApplyInfo',

        component: () => import('@/views/applyTest/applyInfo.vue'),
        meta: {
          hideHead: true,
          hideFoot: true
        }
      },
      {
        path: '/applyinfo/:wating',
        name: 'Wating',

        component: () => import('@/views/applyTest/wating.vue'),
        meta: {
          hideHead: true,
          hideFoot: true
        }
      }
    ]
  }
export default applyRouter
